import React from 'react';
import './App.css';
import TabDashboard from './components/Dashboard';

function App() {
  return (
    <div className="App">
      <TabDashboard />
    </div>
  );
}

export default App;